export const arrayFix = (value) => (Array.isArray(value) ? value : [value]);
export const arrayUnion = (...arrays) => {
    return [...new Set(arrays.flat(1))];
};
//# sourceMappingURL=arrays.js.map